// Keep external navigation separate so the creation flows can be exercised without leaving the app.
export const goToCrmCheckout = url => window.location.assign(url);

export function getCrmCheckoutUrl(access) {
  if (access?.canCreateBoard !== false || access.reason !== 'crm_subscription_required') return null;
  let url;
  try { url = new URL(access.checkoutUrl); } catch { return null; }
  const local = process.env.NODE_ENV === 'development' && ['localhost', '127.0.0.1'].includes(url.hostname);
  if (url.username || url.password || (!local && (url.protocol !== 'https:' || !['payments.doitforme.eu', 'payments.doitforme.club'].includes(url.hostname))) ||
      (local && !['http:', 'https:'].includes(url.protocol))) return null;
  return url.href;
}
